import React from 'react';
import Styles from './styles.js'

export default function TitleTemplate({ title }) {

  return (
    <>
      <div><h2 className={`BUS-head-title text-xl lg:text-2xl border-b-2 pb-3 mb-10 uppercase`}>
        {title}
      </h2></div>
      <Styles/>
    </>
  )
}
